import { render, staticRenderFns } from "./RuralMORE.vue?vue&type=template&id=69799e37&"
import script from "./RuralMORE.vue?vue&type=script&lang=js&"
export * from "./RuralMORE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports